import { createSelector } from 'reselect';

import getDeliveryOrderLeadTimes from './getDeliveryOrderLeadTimes';
import getAverageAsapDeliveryTime from './getAverageAsapDeliveryTime';

/**
 * # getDeliveryAsapDurationBestCaseScenario
 *
 * Gets the best case delivery duration for ASAP delivery.
 * This is used in the helper text below the ASAP option to give the
 * user a rough estimate if they pick ASAP.
 */
export default createSelector(
  [getDeliveryOrderLeadTimes, getAverageAsapDeliveryTime],
  (deliveryOrderLeadTimes, averageAsapDeliveryDuration) => {
    if (deliveryOrderLeadTimes.length == 0) {
      return averageAsapDeliveryDuration;
    }

    return deliveryOrderLeadTimes[0].Time + averageAsapDeliveryDuration;
  },
);
